import CountryNames from "i18n-iso-countries";
// @ts-ignore
import EnglishCountries from "i18n-iso-countries/langs/en";
// @ts-ignore
import SpanishCountries from "i18n-iso-countries/langs/es";
// @ts-ignore
import DutchCountries from "i18n-iso-countries/langs/nl";

// We have to register the languages the library can use so we don't have to load all possible languages
// See https://www.npmjs.com/package/i18n-iso-countries for supported languages
CountryNames.registerLocale(DutchCountries);
CountryNames.registerLocale(EnglishCountries);
CountryNames.registerLocale(SpanishCountries);

export default CountryNames;
